import { phoneCategorySchema, phoneCategoriesSchema } from "./schema";
import { getEntity, getEntities } from "./base";
import { PRODUCT_TYPES } from "../constants/productTypes";

const path = "/portal/api/phone_categories";

const getPhoneCategory = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, phoneCategorySchema);
};

const getPhoneCategoryByEan = (clientConfig, ean) => {
  return getEntity(clientConfig, `find?ean=${ean}`, path);
};

const getPhoneCategoryByPhoneVariantId = (clientConfig, phoneVariantId) => {
  return getEntity(
    clientConfig,
    `find?phone_variant_id=${phoneVariantId}`,
    path
  );
};

const getPhoneCategoryByPhoneId = (clientConfig, phoneId) => {
  return getEntity(clientConfig, `find?phone_id=${phoneId}`, path);
};

const getPhoneCategories = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.dataSpeedGen = [];
  limits.providerId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    phoneCategoriesSchema,
    { productType: PRODUCT_TYPES.phone },
    limits
  );
};

export {
  getPhoneCategory,
  getPhoneCategoryByEan,
  getPhoneCategoryByPhoneId,
  getPhoneCategoryByPhoneVariantId,
  getPhoneCategories
};
